(function(){
  function revealAll(els){
    els.forEach(function(el){ el.classList.add('in'); });
  }

  function revealInit(){
    var els = Array.prototype.slice.call(document.querySelectorAll('.wos-rv:not(.in)'));
    if(!els.length) return;

    // Respect the visitor's motion preference — show everything, animate nothing.
    if(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){
      revealAll(els);
      return;
    }

    // No observer support (very old browsers): show everything rather than hide it.
    if(!('IntersectionObserver' in window)){
      revealAll(els);
      return;
    }

    try {
      var io = new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          if(entry.isIntersecting){
            entry.target.classList.add('in');
            io.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -6% 0px' });

      els.forEach(function(el){ io.observe(el); });
    } catch (e) {
      // If anything goes wrong, never leave content invisible.
      revealAll(els);
    }
  }

  if(document.readyState !== 'loading'){ revealInit(); }
  else { document.addEventListener('DOMContentLoaded', revealInit); }

  // Re-scan when a section is re-rendered in the theme editor.
  document.addEventListener('shopify:section:load', revealInit);
})();
